import styled from 'styled-components';

export const KeyTermWrapper = styled.a.attrs({
  className: 'spf-inline-key-term popover-link',
})`
  font-size: inherit;
  text-decoration: none;
  color: #0073ca;
  cursor: pointer;
  display: inline;
  outline: none;
  
  &:hover {
    opacity: 0.7;
  }
  
  &:focus, &:focus-visible {
    outline: 2px solid #0073ca;
    outline-offset: 2px;
  }
  
  span {
    text-decoration: underline;
  }
`;

// Re-export shared popover styles for backwards compatibility
export { PopoverWrapper, PopoverTitle, CloseButton, PopoverContent } from '../common/popoverStyles';
